import styled from "styled-components";


export const Box = styled.div`
padding: 40px 80px;
font-family: sans-serif;
`;

export const Bold = styled.b`
  color: #4f585e;
`;

export const Para = styled.p`
//   color: #4f585e;
  opacity:0.6;
  font-size: 14px;
`;

export const Insidelink = styled.a`
  color: #10847e;
  &:hover {
    color: #666666;
    // opacity: 0.6;
    text-decoration: none;
  }
`;